import { render, staticRenderFns } from "./ContractsGrid.vue?vue&type=template&id=8af429a8&scoped=true&"
import script from "./ContractsGrid.vue?vue&type=script&lang=js&"
export * from "./ContractsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af429a8",
  null
  
)

export default component.exports